<div *ngIf="waypoints">
  <h4>Intermediate Route Waypoints</h4>
  <p class="fine-print">
    This is where you add additional waypoints if the route has any complexity. We recommend adding a waypoint for the
    entrance to your property. But you don&rsquo;t need one for the ending point as that is already available.
  </p>
  <ng-container *ngFor="let waypoint of waypoints.controls; let i = index" [formGroup]="waypoint">
    <div class="button-wrapper-grid">
      <div class="waypoint-function">
        <div class="direction-wrapper">
          <div (click)="moveUp(i)" class="icon-up">
            <div class="w-embed">
              <curbnturf-misc-svg icon="chevronUp"></curbnturf-misc-svg>
            </div>
          </div>
          <div (click)="moveDown(i)" class="icon-down">
            <div class="w-embed">
              <curbnturf-misc-svg icon="chevronDown"></curbnturf-misc-svg>
            </div>
          </div>
        </div>
        <div (click)="removeWaypoint(i)" class="icon-trash image">
          <div class="html-embed w-embed">
            <curbnturf-misc-svg icon="trash"></curbnturf-misc-svg>
          </div>
        </div>
      </div>
      <div>
        <input
          formControlName="name"
          type="text"
          class="text-input w-input"
          placeholder="Enter name or road description"
        />
      </div>
      <div (click)="setCoordinatesToCurrent(waypoint)" class="cnt-button">
        <div class="cnt-button-copy">Use My Current Location</div>
      </div>
      <div (click)="getCoordinatesFromMap(i)" class="cnt-button">
        <div class="cnt-button-copy">Find On Map</div>
      </div>
      <div class="left-column-wrapper listing">
        <div class="title">Latitude</div>
        <input
          type="number"
          min="-90"
          max="90"
          step="0.000001"
          formControlName="lat"
          class="l-lat-text-field w-input"
        />
      </div>
      <div class="right-column-wrapper listing">
        <div class="title">Longitude</div>
        <input
          type="number"
          min="-180"
          max="180"
          step="0.000001"
          formControlName="lon"
          class="l-lat-text-field w-input"
        />
      </div>
    </div>
    <div class="divider-line"></div>
  </ng-container>

  <div class="button-wrapper-grid">
    <div (click)="addWaypoint()" class="cnt-button">
      <div class="cnt-button-copy">Add a waypoint</div>
    </div>
  </div>
</div>
